export default "__VITE_ASSET__DTGQ68zc__"